import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { takeWhile } from 'rxjs';

@Component({
  selector: 'app-redirect',
  template: '',
  styles: []
})
export class RedirectComponent implements OnInit, OnDestroy {
  alive = true;

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit() {
    this.authService.currentUser$.pipe(takeWhile(() => this.alive)).subscribe((user) => {
      if (user.is_manager) {
        this.router.navigate(['/briefcase']);
      } else {
        this.router.navigate(['/frontend', 'dashboard']);
      }
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
